import {
  EAutopaymentError,
  MIN_PAYKEEPER_AMOUNT,
  VALIDATION_PAYKEEPER_AUTOPAYMENT_AMOUNT,
} from './definitions';

export default {
  topUpBalance: 'Пополнить баланс',
  payKeeperSettingsModal: {
    title: 'Оплатить картой через платежную систему',
    amount: 'Введите сумму платежа для зачисления',
    minAmount: `Минимальная сумма — ${MIN_PAYKEEPER_AMOUNT} {{currency}}`,
    chooseCard: 'Выберите карту',
    saveCard: 'Сохранить карту для последующих платежей',
    savedCard: 'Сохраненная карта',
    newCard: 'Новая карта',
    replaceCard: 'Сохранить новую карту вместо текущей',
    acceptanceInfo:
      'Нажимая "Оплатить", вы будете перенаправлены на сайт платежной системы PayKeeper',
    pay: 'Оплатить',
  },
  payKeeperDeleteCardModal: {
    title: 'Удалить сохраненную карту?',
    subtitle: 'Тогда нужно будет заново вводить данные платежной карты при следующем платеже',
    submit: 'Удалить',
  },
  payKeeperAutopaymentInfo:
    'В последний день месяца автоматически пополнять счет на <0>{{amount}}</0> <1>₽</1>',
  payKeeperOffAutopaymentModal: {
    title: 'Отключить автоплатеж за лицензии?',
    subtitle:
      'Если отключить автоплатеж, не произойдет оплата ваших лицензий на следующий срок. С неактивными лицензиями вы не сможете пользоваться нашим сервисом и отправлять сообщения вашим клиентам.',
    submitButton: 'Отключить',
  },
  payKeeperAutopaymentSettingsModal: {
    title: 'Настроить автоплатеж за лицензии',
    editTitle: 'Изменить сумму автоплатежа',
    amount: 'Введите сумму автоплатежа',
    minAmount: `Минимальная сумма ${MIN_PAYKEEPER_AMOUNT} ₽`,
    licensesInfo:
      'Мы рекомендуем указать вам сумму автоплатежа в размере не менее <0>{{threshold}}</0> ₽ – это стоимость всех ваших лицензий + минимальный платеж для Viber и абонентская плата за отправителя для SMS (если есть).\n\n' +
      'Автоплатеж будет списываться с указанной карты в последний день месяца.',
    validationInfo: `Для валидации подключённой карты, с ее баланса будет списан ${VALIDATION_PAYKEEPER_AUTOPAYMENT_AMOUNT}₽, который будет возвращен после подключения.\n\n`,
    acceptanceInfo:
      'Нажимая кнопку "Продолжить", вы будете перенаправлены на сайт платёжного сервиса PayKeeper.',
    lowSumWarning: 'Настроенная вами сумма автоплатежа будет недостаточной для оплаты лицензий',
  },
  payKeeperChangeCardCreditsModal: {
    title: 'Изменить карту автоплатежа',
    subtitle:
      'Чтобы изменить карту автоплатежа, введите данные новой карты на странице платежного сервиса PayKeeper',
  },
  stripeAutopaymentSettingsModal: {
    titleConnect: 'Подключить автоплатеж',
    titleEdit: 'Настроить автоплатеж',
    threshold: 'При остатке на балансе менее',
    amount: 'Пополнить счет на',
    minThreshold: 'Минимальный баланс – {{threshold}} {{currency}}',
    minAmount: 'Минимальная сумма пополнения – {{amount}} {{currency}}',
    acceptanceInfo: 'После применения вы будете перенаправлены на сайт платежной системы Stripe',
    licensesInfo:
      'Мы рекомендуем установить баланс не менее <0>{{threshold}} {{currency}}</0>. Это стоимость всех ваших лицензий и минимальный платеж для Viber, если есть.',
    incorrectSettingsWarning:
      'Установленной вами суммы недостаточно для своевременного продления лицензий. Если банк будет списывать средства несколько раз, могут возникнуть перебои в работе сервиса',
  },
  stripeOffAutopaymentModal: {
    title: 'Хотите отключить автоплатеж?',
    subtitle:
      'Если отключить автоплатеж, ваши лицензии перестанут продлеваться автоматически. Это значит, что вы не сможете пользоваться нашими услугами и отправлять сообщения вашим клиентам.',
    submitButton: 'Запросить отключение',
  },
  stripeAutopaymentSupportModal: {
    title: {
      on: 'Подключить автоплатеж?',
      off: 'Отключить автоплатеж?',
    },
    subtitle:
      'Автоплатеж позволяет автоматически пополнять баланс с банковской карты на указанную сумму. Вы уверены?',
    submitButton: {
      on: 'Подключить',
      off: 'Отключить',
    },
  },
  stripeChargeAutopaymentModal: {
    title: 'Выполнить попытку списания',
    subtitle:
      'Будет выполнена попытка списания ранее сформированного инвойса, который не был оплачен из-за ошибок. Если открытого инвойса нет, списание выполнено не будет. Вы уверены?',
    submitButton: 'Выполнить',
  },
  stripeChangeCardCreditsModal: {
    title: 'Изменить данные карты для автоплатежа',
    subtitle:
      'Для изменения данных привязанной карты вы будете перенаправлены на сайт платежной системы Stripe',
  },
  stripeAutopaymentInfo:
    'Когда на балансе будет <1>{{threshold}}</1> <0>{{currency}}</0> он автоматически пополнится на <2>{{amount}}</2> <0>{{currency}}</0>',
  autopaymentStatus: {
    connected: 'Автоплатеж подключен',
    paused: 'Автоплатеж приостановлен',
    savedCard: 'Сохраненная карта',
  },
  actions: {
    topUp: 'Пополнить',
    generateInvoice: 'Сформировать счет',
    payByCard: 'Оплатить картой',
    deleteCard: 'Удалить карту',
    deleteAutopayment: 'Удалить автоплатеж',
    connectAutopayment: 'Подключить автоплатеж',
    chargeAutopayment: 'Выполнить попытку списания',
    connectAutopaymentHint:
      'Автоплатеж позволяет автоматически пополнять баланс с банковской карты на указанную сумму',
    changeAutopaymentSettings: 'Изменить автоплатеж',
    changeAmount: 'Изменить сумму',
    changeCardCredits: 'Изменить данные карты',
    offAutopayment: 'Отключить автоплатеж',
    restoreAutopayment: 'Возобновить автоплатеж',
  },
  payKeeperThresholdWarning: {
    owner:
      'Размер автоплатежа меньше суммы регулярных платежей. Мы рекомендуем увеличить автоплатеж, чтобы хватало средств для продления лицензии. <0>Обновить автоплатеж</0>',
    others:
      'Размер автоплатежа меньше суммы регулярных платежей. Мы рекомендуем увеличить автоплатеж, чтобы хватало средств для продления лицензии',
  },
  thresholdWarning:
    'Установленного минимального баланса может не хватить для оплаты ваших регулярных платежей. Мы рекомендуем обновить автоплатеж для своевременного продления лицензий. <0>Обновить автоплатеж</0>',
  invoiceSettingsModal: {
    title: 'Сформировать счет на оплату',
    amount: 'Вставьте произвольную сумму, на которую вы бы хотели получить счет',
    warning:
      'Не забудьте при оплате учесть все сторонние комиссии за переводы и операции обмена валют.',
    generateButton: 'Сформировать',
    insertSum: 'Введите сумму',
  },
  invoiceGeneratedModal: {
    title: 'Счет сформирован',
    content: `Ваш баланс будет пополнен после зачисления средств. Счет будет доступен в разделе <0>Документы</0>.`,
    download: 'Загрузить счет',
  },
  stripeSettingsModal: {
    title: 'Оплатить картой через платежную систему <0></0>',
    topUp: 'Оплатить',
    amount: 'Сумма платежа',
    cancel: 'Отмена',
    warning:
      'Обращаем ваше внимание, что сумма платежа будет зачислена на ваш текущий баланс на основании оферты. При возникновении вопросов по зачислению денежных средств или ошибочному платежу просьба обращаться по адресу support@edna.ru',
    content:
      'Нажимая на кнопку “Оплатить”, вы будете перенаправлены на сайт платёжного сервиса Stripe',
  },
  errors: {
    [EAutopaymentError.INSUFFICIENT_FUNDS]:
      'Не удалось выполнить списание {{date}}. Недостаточно средств на карте. Пополните карту в течение {{leftDays}} {{leftDays1}}, чтобы повторно выполнить автоплатеж. Если через {{leftDays}} {{leftDays2}} на балансе будет недостаточно средств, автоплатеж будет отключен и услуги приостановлены. Следующая попытка списания будет {{nextDate}}',
    [EAutopaymentError.CARD_DECLINE]:
      'Не удалось выполнить автоплатеж с помощью привязанной карты. Проверьте данные карты',
    [EAutopaymentError.AUTHENTICATION_REQUIRED]:
      'Не удалось выполнить автоплатеж {{date}}. Ваш банк запросил подтверждение платежа. Чтобы подтвердить платеж, перейдите на <0>сайт платежной системы Stripe</0>.',
    payKeeperAutopayment: 'Ошибка при пополнении счета картой {{date}}',
    payKeeperAutopaymentTenantBlocked:
      'Ваш аккаунт временно неактивен, автоплатеж возобновится после перехода аккаунта в статус "Активный"',
  },
};
